// Maps a FilterBar `values` object into flat API query params.
//
// Each field carries the param name(s) the backend expects:
//   multiselect / select / text -> `param` (defaults to field id), sent as a value or CSV
//   numberrange                 -> `minParam` / `maxParam`
//   daterange                   -> `fromParam` / `toParam`
// Empty values are omitted so they never reach the query string.
export function buildFilterParams(fields, values) {
  const out = {};
  for (const f of fields) {
    const v = values?.[f.id];
    if (v == null) continue;
    switch (f.type) {
      case 'multiselect':
        if (Array.isArray(v) && v.length) out[f.param || f.id] = v.join(',');
        break;
      case 'numberrange':
        if (v.min !== '' && v.min != null) out[f.minParam] = v.min;
        if (v.max !== '' && v.max != null) out[f.maxParam] = v.max;
        break;
      case 'daterange':
        if (v.from) out[f.fromParam] = v.from;
        if (v.to) out[f.toParam] = v.to;
        break;
      case 'select':
      case 'text':
      default:
        if (v !== '') out[f.param || f.id] = v;
        break;
    }
  }
  return out;
}
